import {
  GENERATE_LINK_REQUEST, GENERATING_LINK_SUCCEDDED, GENERATING_LINK_FAILED,
  FETCH_ALL_NDA_TEMPLATE_REQUEST, FETCHING_ALL_NDA_TEMPLATE_SUCCEDDED, FETCHING_ALL_NDA_TEMPLATE_FAILED,
  GENERATING_LINK_FOR_ENTITY, GENERATING_LINK_FOR_ENTITY_FAILED, GENERATING_LINK_FOR_ENTITY_SUCCEEDED, INVALIDATE_GENERATE_LINK
} from 'constants/actionTypes';

const initialState = {
  item: null,
  loading: false,
  creating: false,
  nda: {
    templates: null,
    loading: false,
    error: null
  }
}

function linksReducer(state = initialState, action) {
  switch (action.type) {
    
    case GENERATE_LINK_REQUEST:
      return {
        ...state,
        creating: true
      };

    case GENERATING_LINK_SUCCEDDED:
      var response = action.payload;

      return {
        ...state,
        creating: false,
        item: response
      };

    case GENERATING_LINK_FAILED:
      var error = action.payload;

      return {
        ...state,
        creating: false,
        error: error
      };  

    case FETCH_ALL_NDA_TEMPLATE_REQUEST:
      return {
        ...state,
        nda: {
          loading: true
        }
      };

    case FETCHING_ALL_NDA_TEMPLATE_SUCCEDDED:
      var response = action.payload;

      return {
        ...state,
        nda: {
          loading: false,
          templates: action.payload,
          error: null
        }
      };

    case FETCHING_ALL_NDA_TEMPLATE_FAILED:
      var error = action.payload;

      return {
        ...state,
        nda: {
          loading: false,
          templates: null,
          error: action.payload
        }
      };  
    
    case GENERATING_LINK_FOR_ENTITY:
      return {
        ...state,
        [action.payload.entity.id]: {
          [action.payload.request.type]: {
            generating: true
          }
        }
      }
    
    case GENERATING_LINK_FOR_ENTITY_SUCCEEDED:
      return {
        ...state,
        [action.payload.entity.id]: {
          [action.payload.type]: {
            generating: false,
            url: action.payload.url,
            utmCampaign: action.payload.utmCampaign
          }
        }
      }
    
    case GENERATING_LINK_FOR_ENTITY_FAILED:
      return {
          ...state,
        [action.payload.entity.id]: {
          [action.payload.request.type]: {
            generating: false,
            error: action.payload.error.errors
            }
          }
      }
    
    case INVALIDATE_GENERATE_LINK: {
      return initialState;
    }
    
    default:
      return state;
  }
}

export { linksReducer };